import { Box, Typography } from '@mui/material';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import zeplinColor from 'theme/Color';
import Card from '../../News/Card';

const RecentNews = ({ data }: { data: any }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${zeplinColor.Neutral5}`,
        padding: '16px',
        gap: '12px',
        borderRadius: '14px',
        width: '100%',
        overflowY: 'scroll',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='responsiveHeading3'>Recent Company News</Typography>
        <CustomButton
          disabled={false}
          onClick={() => {
            // setValue(3);
          }}
          variant='text'
          color='secondary'
          style={{
            textAlign: 'center',
            gap: '16px',
          }}
          textStyle={{ color: zeplinColor.BasicBlack }}
          text={'See All'}
          icon={''}
          buttonVariant='buttonSmall'
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        {data && data.length ? (
          data.map((item: any) => <Card key={item.title} val={item} variant='small' />)
        ) : (
          <NoRecentNews />
        )}
      </Box>
    </Box>
  );
};

export default RecentNews;

const NoRecentNews = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        // justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        width: '100%',
      }}
    >
      <img src={'/assets/no-news.svg'} />
      <Typography variant='responsiveHeading3'>No News Available</Typography>
      <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
        Currently, there are no news items to display. Check back later for updates and insights.
      </Typography>
    </Box>
  );
};
